import React, { useEffect, useRef } from 'react';
import gsap from 'gsap';
import { FiMail, FiPhone, FiMapPin, FiClock } from 'react-icons/fi';

const ContactInfo = () => {
    const containerRef = useRef(null);

    useEffect(() => {
        // Simple reveal animation
        gsap.fromTo(".info-card",
            { y: 30, opacity: 0 },
            { y: 0, opacity: 1, duration: 0.8, stagger: 0.2 }
        );
    }, []);

    const cards = [
        { icon: <FiMail />, title: "Email Us", desc: "info@rojrztech.com", extra: "We'll respond within 24 hours" },
        { icon: <FiPhone />, title: "Call Us", desc: "+1 (512) 254-4193", extra: "Mon - Fri, 9AM - 6PM" },
        { icon: <FiMapPin />, title: "Visit Us", desc: "5900, Balcones Drive, STE 100", extra: "Austin, Texas, 78731" },
        { icon: <FiClock />, title: "Working Hours", desc: "Monday - Friday", extra: "Weekend Closed" },
    ];

    return (
        <section ref={containerRef} className="py-20 px-6 max-w-7xl mx-auto">
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
                {cards.map((card, index) => (
                    <div
                        key={index}
                        className="info-card bg-[#111] p-8 rounded-3xl border border-white/5 hover:border-[#F2B135] transition-all duration-500 cursor-pointer group"
                    >
                        <div className="text-[#F2B135] text-3xl mb-6 group-hover:scale-110 transition-transform duration-300">
                            {card.icon}
                        </div>
                        <h3 className="text-white font-bold text-xl mb-2">{card.title}</h3>
                        <p className="text-white text-lg font-semibold mb-1">{card.desc}</p>
                        <p className="text-[#F2B135]/80 text-sm">{card.extra}</p>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default ContactInfo;